import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { JobDataPickerComponent } from './job-data-picker.component';

@NgModule({
  declarations: [
    JobDataPickerComponent
  ],
  imports: [
    SharedModule
  ],
  exports:[
    JobDataPickerComponent
  ]
})
export class JobDataPickerModule { }
